export const defaultNoteDateFormat = 'MMM D, LT';
export const defaultPrintedNoteDateFormat = 'L LTS';